import * as React from "react";
import { createContext, useCallback, useContext, useMemo } from "react";
import { stylesheet } from "typestyle";
import { classNames } from "./utils.js";
import { IconNames, MaterialIcon } from "./icon.js";
export const TableSortContext = createContext({ onSort: () => { } });
export function useTableSortContext() {
    return useContext(TableSortContext);
}
export function Table({ sort, onSort, children }) {
    const handleSort = useCallback((next) => {
        if (onSort) {
            onSort(next);
        }
    }, [onSort]);
    const context = useMemo(() => ({
        sort: sort,
        onSort: handleSort
    }), [sort, handleSort]);
    return (React.createElement(TableSortContext.Provider, { value: context },
        React.createElement("table", { className: styles.table }, children)));
}
export function TableHead({ children }) {
    return (React.createElement("thead", { className: styles.head }, children));
}
export function TableBody({ children }) {
    return (React.createElement("tbody", null, children));
}
export function TableFoot({ children }) {
    return (React.createElement("tfoot", null, children));
}
export function TableRow({ className, children, onClick }) {
    return (React.createElement("tr", { className: classNames(styles.row, className), onClick: onClick }, children));
}
export function TableCell({ children, className, column, ...props }) {
    const tableSortContext = useTableSortContext();
    const sortOrder = useMemo(() => {
        const { sort } = tableSortContext;
        if (column && sort && sort.column === column) {
            return sort.order;
        }
        return undefined;
    }, [column, tableSortContext]);
    const handleSort = useCallback(() => {
        if (!column) {
            return;
        }
        const { sort } = tableSortContext;
        const direction = (sort && sort.column === column) ? (sort.order == 'asc' ? 'desc' : 'asc') : 'asc';
        const next = {
            column: column,
            order: direction
        };
        tableSortContext.onSort(next);
    }, [column, tableSortContext]);
    return (React.createElement("td", { className: classNames(styles.cell, className), ...props, onClick: handleSort },
        children,
        sortOrder == 'asc' && React.createElement(MaterialIcon, { icon: IconNames.north, className: styles.sortIndicator }),
        sortOrder == 'desc' && React.createElement(MaterialIcon, { icon: IconNames.south, className: styles.sortIndicator })));
}
const styles = stylesheet({
    table: {
        borderCollapse: "collapse",
        width: "100%"
    },
    head: {
        opacity: 0.75,
        fontWeight: "bold",
    },
    row: {},
    cell: {
        padding: "0.5em 1em",
        borderBottom: "1px solid var(--color-separator)",
    },
    sortIndicator: {
        paddingLeft: "0.25em",
        fontSize: "0.8em"
    }
});
//# sourceMappingURL=table.js.map